<template>
  <section>
    <main class="main animated fadeIn faster" :class="{ 'expand-main': false }">
      <div class="contenedor py-0">
        <div class="col-4">
          <h2>Affiliates Comissions</h2>
        </div>
        <div v-if="loading" class="container-fluid w-100 mb-3 p-3  bg-white rounded stats-wrapper">
          <div class="row">
            <div class="col-12">
              <LoadingSpinner></LoadingSpinner>
            </div>
          </div>
        </div>
        <Tabs v-if="!loading" :tabs="mainTabs" v-model="activeTab" :tabSelected="activeTab" @change="changeTab($event)"/>
        <div v-if="activeTab === 1 && !loading">
          <!-- TAB 1: Commissions on leads (10%) -->
          <div class="row p-3">
            <div class="col-md-12 w-100 mb-3 card p-0">
              <div class="card-body">
                <div class="row" :class="{ 'justify-content-center': hasPermissions('isReferal') }">
                  <!-- DATE FROM -->
                  <div class="w-50 input-group input-group-sm p-1 col-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Year</span>
                    </div>
                    <select class="form-control" v-model="yearSelected">
                      <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                  </div>
                  <div class="float-right ml-5" v-if="hasPermissions('isReferal')">
                    <button class="btn btn-success" :disabled="loading" @click="getAffiliate()">
                      <i class="icon-calendar-check-o mr-2"></i>
                      <small>
                        {{ $t("lang.label.letsgetstarted") }}
                      </small>
                    </button>
                  </div>
                  <div class="w-50 input-group input-group-sm p-1 treeselect-wrapper col-4"
                    v-if="['1'].includes(currentUser.role_id)">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Role</span>
                    </div>
                    <treeselect v-model="model.role_ids" :options="roles" :normalizer="normalizeOptions" :multiple="true"
                      class="form-control inline-table">
                    </treeselect>
                  </div>
                  <div class="w-50 input-group input-group-sm p-1 treeselect-wrapper col-4"
                    v-if="['1'].includes(currentUser.role_id)">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Users</span>
                    </div>
                    <treeselect v-model="model.user_ids" :options="users" :normalizer="normalizeOptions" :multiple="true"
                      class="form-control inline-table">
                    </treeselect>
                  </div>
                </div>
              </div>
              <div class="w-25 p-1 ml-auto" v-if="!hasPermissions('isReferal')">
                <div class="col-md-12 d-flex justify-content-end my-2">
                  <button class="btn btn-success" :disabled="loading" @click="getAffiliate()">
                    <i class="icon-calendar-check-o mr-2"></i>
                    <small>
                      {{ $t("lang.label.letsgetstarted") }}
                    </small>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 w-100 mb-3 card p-0">
            <div class="row">
              <div class="col-12 ">
                <span class="mx-2 mt-2 text-bold ">{{ $t("lang.label.results") }}: <strong>{{ model.total }}</strong>
                </span>
              </div>
              <div class="col-md-12 mt-4">
                <div class="p-2" v-if="!loading">
                  <table class="w-100 table table-hover bg-white">
                    <thead>
                      <th v-for="header in headers" :key="header.id" scope="">{{ header.label }}</th>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in stats" :key="index">
                        <td class="text-primary cursor-pointer" @click="goToUser(item.username_id)">{{ item.username }}</td>
                        <td>{{ item.company_name }}</td>
                        <td>{{ item.role }}</td>
                        <td class="text-primary cursor-pointer" @click="goToClient(item.id)">{{ item.client }}</td>
                        <td>{{ item.client_status }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M01 > 0 }">{{ item.M01 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M02 > 0 }">{{ item.M02 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M03 > 0 }">{{ item.M03 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M04 > 0 }">{{ item.M04 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M05 > 0 }">{{ item.M05 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M06 > 0 }">{{ item.M06 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M07 > 0 }">{{ item.M07 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M08 > 0 }">{{ item.M08 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M09 > 0 }">{{ item.M09 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M10 > 0 }">{{ item.M10 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M11 > 0 }">{{ item.M11 }}</td>
                        <td :class="{ 'text-success font-weight-bold': item.M12 > 0 }">{{ item.M12 }}</td>
                        <td class="font-weight-bold">{{ getRowTotal(item).toFixed(2) }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="5" class="table-active font-weight-bold">Total</td>
                        <td v-for="month in months" :key="month" class="font-weight-bold table-active">
                          {{ totalStats[month].toFixed(2) }}
                        </td>
                        <td class="font-weight-bold table-active">{{ getTotalStatsSum().toFixed(2) }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 2 && !loading">
          <!-- TAB 2: Clients Signed (€1000/client) -->
          <div class="row p-3">
            <div class="col-md-12 w-100 mb-3 card p-0">
              <div class="card-body">
                <div class="row" :class="{ 'justify-content-center': hasPermissions('isReferal') }">
                  <div class="w-50 input-group input-group-sm p-1 col-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Year</span>
                    </div>
                    <select class="form-control" v-model="yearSelected">
                      <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                  </div>
                  <div class="float-right ml-5" v-if="hasPermissions('isReferal')">
                    <button class="btn btn-success" :disabled="loadingSigned" @click="getSignedClients()">
                      <i class="icon-calendar-check-o mr-2"></i>
                      <small>
                        {{ $t("lang.label.letsgetstarted") }}
                      </small>
                    </button>
                  </div>
                  <div class="w-50 input-group input-group-sm p-1 treeselect-wrapper col-4"
                    v-if="['1'].includes(currentUser.role_id)">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Role</span>
                    </div>
                    <treeselect v-model="signedModel.role_ids" :options="roles" :normalizer="normalizeOptions" :multiple="true"
                      class="form-control inline-table">
                    </treeselect>
                  </div>
                  <div class="w-50 input-group input-group-sm p-1 treeselect-wrapper col-4"
                    v-if="['1'].includes(currentUser.role_id)">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm">Users</span>
                    </div>
                    <treeselect v-model="signedModel.user_ids" :options="users" :normalizer="normalizeOptions" :multiple="true"
                      class="form-control inline-table">
                    </treeselect>
                  </div>
                </div>
              </div>
              <div class="w-25 p-1 ml-auto" v-if="!hasPermissions('isReferal')">
                <div class="col-md-12 d-flex justify-content-end my-2">
                  <button class="btn btn-success" :disabled="loadingSigned" @click="getSignedClients()">
                    <i class="icon-calendar-check-o mr-2"></i>
                    <small>
                      {{ $t("lang.label.letsgetstarted") }}
                    </small>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 w-100 mb-3 card p-0">
            <div class="row">
              <div class="col-12 ">
                <span class="mx-2 mt-2 text-bold ">
                  {{ $t("lang.label.results") }}: <strong>{{ signedModel.total }}</strong>
                </span>
              </div>
              <div class="col-md-12 mt-4">
                <div class="p-2" v-if="!loadingSigned">
                  <table class="w-100 table table-hover bg-white">
                    <thead>
                      <th>User</th>
                      <th>Role</th>
                      <th v-for="month in months" :key="month">{{ month }}</th>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in signedStats" :key="index">
                        <td>{{ item.user }}</td>
                        <td>{{ item.role }}</td>
                        <td v-for="month in months" :key="month">
                          {{ item[month] * item.fixed_fee_amount }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="2" class="table-active font-weight-bold">Total</td>
                        <td v-for="month in months" :key="month" class="font-weight-bold table-active">
                          {{ totalSignedStats[month] }}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Table from "@/components/Common/Table.vue";
import { clientsService, usersService } from "@/_services";
import Pagination from "@/components/Common/Pagination.vue";
import Treeselect from "@riophae/vue-treeselect";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
export default {
  name: "Affiliates Comissions",
  components: {
    Table,
    Pagination,
    Treeselect,
    Tabs,
    LoadingSpinner,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    ...mapGetters('authentication', ['hasPermissions']),
  },
  data() {
    return {
      mainTabs: {
        1: {
          id: 1,
          name: "Commissions on leads",
        },
        2: {
          id: 2,
          name: "Clients Signed",
        },
      },
      
      activeTab: 1,
      loading: false,
      stats: [],
      users: [],
      yearSelected: 2026,
      totalStats: {
        M01: 0, M02: 0, M03: 0, M04: 0, M05: 0, M06: 0,
        M07: 0, M08: 0, M09: 0, M10: 0, M11: 0, M12: 0
      },
      roles: [
        { id: 5, name: "Agency" },
        { id: 7, name: "Referal" },
      ],
      availableYears: [
        2020,2021,2022,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034,2035,2036,2037,2038,2039,2040,2041,2042,2043,2044,2045,2046,2047,2048,2049,2050
      ],
      headers: [
        {label: "Username", id: 1},
        { label: "User", id: 2 },
        { label: "Role", id: 3 },
        { label: "Client", id: 4 },
        { label: "Client status", id: 5 },
        { label: "M01", id: 6 },
        { label: "M02", id: 7 },
        { label: "M03", id: 8 },
        { label: "M04", id: 9 },
        { label: "M05", id: 10 },
        { label: "M06", id: 11 },
        { label: "M07", id: 12 },
        { label: "M08", id: 13 },
        { label: "M09", id: 14 },
        { label: "M10", id: 15 },
        { label: "M11", id: 16 },
        { label: "M12", id: 17 },
        { label: "Total", id: 18 }
      ],
      cols: [
        [{ value: "company_name" }],
        [{ value: "role" }],
        [{ value: "client" }],
        [{ value: "client_status" }],
        [{ value: "M01" }],
        [{ value: "M02" }],
        [{ value: "M03" }],
        [{ value: "M04" }],
        [{ value: "M05" }],
        [{ value: "M06" }],
        [{ value: "M07" }],
        [{ value: "M08" }],
        [{ value: "M09" }],
        [{ value: "M10" }],
        [{ value: "M11" }],
        [{ value: "M12" }],
      ],
      model: {
        year: 2025,
        user_ids: [],
        role_ids: [5, 7],
        cantPerPage: 50000,
        currentPage: 1,
        total: 0,
        total_pages: 0
      },
      months: ["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],
      signedStats: [],
      totalSignedStats: {
        M01: 0, M02: 0, M03: 0, M04: 0, M05: 0, M06: 0,
        M07: 0, M08: 0, M09: 0, M10: 0, M11: 0, M12: 0
      },
      signedModel: {
        year: "2025",
        user_ids: [],
        role_ids: [5, 7],
        cantPerPage: 50000,
        currentPage: 1,
        total: 0,
        total_pages: 0
      },
      loadingSigned: false,
      captainkey: 0,
    };
  },
  created() {
    this.loading = true;
    if (this.currentUser.role_id != 1) {
      this.model.user_ids.push(this.currentUser.id);
      this.signedModel.user_ids.push(this.currentUser.id);
    } else {
      this.model.user_ids = [];
      this.model.role_ids = [5 , 7];
      this.signedModel.user_ids = [];
      this.signedModel.role_ids = [5 , 7];
    }
    this.getAffiliate();
    this.getUserByRole();
  },
  watch: {
    activeTab(val) {
      if (val === 1) {
        this.getSignedClients();
      }else{
        console.log(val)
      }
    }
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild"
    }),
    setHeader() {
      this.setCurrentRoute({ page: "affiliation", label: "Affiliates Comissions" });
      this.setCurrentRouteChild({ child: "" });
    },
    getRowTotal(item) {
      return this.months.reduce((sum, m) => sum + (parseFloat(item[m]) || 0), 0);
    },
    getTotalStatsSum() {
      return this.months.reduce((sum, m) => sum + (this.totalStats[m] || 0), 0);
    },
    changeTab(tabId) {
      this.loading = true
      this.activeTab = tabId;
      if(tabId === 1) {
        this.getAffiliate();
      } else if(tabId === 2) {
        this.getSignedClients();
      }
    },
    goToUser(user_id) {
      window.open("/users/" + user_id, "_blank");
    },
    getUserByRole(){
      const roles = [5, 7];
      usersService.getUsersByRole(roles)
        .then(response => {
          this.users = response;
        })
        .catch(error => {
          console.error("Error al cargar los usuarios:", error);
        });
    },
    goToClient(clientId){
      if(this.currentUser.role_id != 1) return;
      let url = "/clients/" + clientId; 
      window.open(url, "_blank");
    },
    getAffiliate() {
      this.loading = true;
      this.model.signed = false;
      if(this.model.role_ids.length == 0) this.model.role_ids = [5,7];
      this.totalStats = {
        M01: 0, M02: 0, M03: 0, M04: 0, M05: 0, M06: 0,
        M07: 0, M08: 0, M09: 0, M10: 0, M11: 0, M12: 0
      };
      this.model.year = this.yearSelected;
      console.log(this.model,this.yearSelected)
      clientsService.getAffiliate(this.model)
        .then((response) => {
          this.stats = response.data;
          this.model.cantPerPage = response.pagination.per_page;
          this.model.currentPage = response.pagination.page;
          this.model.total = response.pagination.total;
          this.model.total_pages = response.pagination.total_pages;
          this.stats.forEach(element => {
            if (element.M01 > 0) this.totalStats.M01 += parseFloat(element.M01);
            if (element.M02 > 0) this.totalStats.M02 += parseFloat(element.M02);
            if (element.M03 > 0) this.totalStats.M03 += parseFloat(element.M03);
            if (element.M04 > 0) this.totalStats.M04 += parseFloat(element.M04);
            if (element.M05 > 0) this.totalStats.M05 += parseFloat(element.M05);
            if (element.M06 > 0) this.totalStats.M06 += parseFloat(element.M06);
            if (element.M07 > 0) this.totalStats.M07 += parseFloat(element.M07);
            if (element.M08 > 0) this.totalStats.M08 += parseFloat(element.M08);
            if (element.M09 > 0) this.totalStats.M09 += parseFloat(element.M09);
            if (element.M10 > 0) this.totalStats.M10 += parseFloat(element.M10);
            if (element.M11 > 0) this.totalStats.M11 += parseFloat(element.M11);
            if (element.M12 > 0) this.totalStats.M12 += parseFloat(element.M12);
          });
        })
        .catch((error) => {
          console.error("Error fetching affiliate data:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSignedClients() {
      this.loading = true;
      this.model.signed = true;
      
      this.model.year = this.yearSelected;
      console.log(this.model,this.yearSelected)
      this.totalSignedStats = {
        M01: 0, M02: 0, M03: 0, M04: 0, M05: 0, M06: 0,
        M07: 0, M08: 0, M09: 0, M10: 0, M11: 0, M12: 0
      };
      clientsService.getAffiliate(this.model)
        .then((response) => {
          this.signedStats = response.data;
          this.signedModel.cantPerPage = response.pagination.per_page;
          this.signedModel.currentPage = response.pagination.page;
          this.signedModel.total = response.pagination.total;
          this.signedModel.total_pages = response.pagination.total_pages;
          this.signedStats.forEach(element => {
            this.months.forEach(m => {
              if (element[m] > 0) this.totalSignedStats[m] += parseFloat(element[m]);
            });
          });
        })
        .catch((error) => {
          console.error("Error fetching signed clients data:", error);
        })
        .finally(() => {
         this.loading = false;
        });
    },
    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name + ' ' + node.lastname,
      };
    },
  }
};
</script>